<template>
  <inventoryProvidersForm :typeEndPoint="'inventoryProvidersShow'" :dataParams="this.$route.params" />
</template>
<script>
import inventoryProvidersForm from '@/components/modules/inventory/providers/form'
export default {
  name: 'inventoryProvidersEdit',
  components: {
    inventoryProvidersForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/providers/edit.vue